export default async function (formData) {
  console.warn('Recaptcha is not implemented yet.');
  /*
  if (window.grecaptcha) {
    const recaptchaKey = window.recaptchaSiteKey;
    window.grecaptcha.ready(async () => {
      const token = await window.grecaptcha.execute(recaptchaKey, { action: 'submit' });
      formData.append('g-recaptcha-response', token);
    });
  } else {
    console.warn('Recaptcha is not loaded.');
  }
  */
}
